/**
 * "Likelihood of this person to recommend Altai" star rating on the contact page.
 *
 * Saves immediately via its own endpoint so the backend can record who set
 * the value and when. Reuses the shared .star-rating styles and interactivity.
 */
import { attachStarRatingInteractivity } from '../common/components/StarRating.js';

function getCsrfToken() {
    return document.querySelector('[name=csrfmiddlewaretoken]')?.value;
}

function render(container, state) {
    const rating = state.rating ?? 0;

    let starsHtml = '<div class="star-rating" data-interactive="true">';
    for (let i = 1; i <= 5; i++) {
        starsHtml += `<span class="star ${i <= rating ? 'star-full' : 'star-empty'}" data-rating="${i}">★</span>`;
    }
    starsHtml += '</div>';

    let infoHtml = '';
    if (state.rating !== null && state.setBy) {
        infoHtml = `<div class="rating-info text-muted small">Set by ${state.setBy}${state.setAt ? ' on ' + state.setAt : ''}</div>`;
    } else if (state.rating === null) {
        infoHtml = '<div class="rating-info text-muted small">Not rated yet</div>';
    }

    const clearHtml = state.rating !== null
        ? '<button type="button" class="btn btn-link btn-sm p-0 recommend-clear">Clear</button>'
        : '';

    container.innerHTML = `<div class="d-flex align-items-center gap-2 flex-wrap">${starsHtml}${clearHtml}</div>${infoHtml}`;

    attachStarRatingInteractivity(container, {
        currentRating: rating,
        onRate: (value) => save(container, value),
    });

    container.querySelector('.recommend-clear')?.addEventListener('click', () => save(container, null));
}

async function save(container, rating) {
    const contactId = container.dataset.contactId;
    try {
        const resp = await fetch(`/projects/contact/${contactId}/recommend-rating/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken(),
            },
            body: JSON.stringify({ rating }),
        });
        const data = await resp.json();
        if (data.success) {
            render(container, {
                rating: data.rating ?? null,
                setBy: data.set_by,
                setAt: data.set_at,
            });
        } else {
            console.error('Failed to save rating:', data.error);
        }
    } catch (err) {
        console.error('Failed to save rating:', err);
    }
}

export function initContactRecommendRating(container) {
    const raw = container.dataset.rating;
    render(container, {
        rating: raw === '' || raw === undefined ? null : parseInt(raw),
        setBy: container.dataset.setBy || null,
        setAt: container.dataset.setAt || null,
    });
}
